import Joi from '../../../Lib/Utils/Joi';

export default {
  pageTitle: 'Garment Production',
  cards: [
    {
      title: 'Details',
      fields: [
        {
          label: 'Sample capacity per week',
          name: 'sampleCapacityPerWeek',
          required: true,
          type: 'text',
          specialValidation: Joi.number().integer().min(0),
          inputType: 'number',
        },
      ],
    },
    {
      title: 'Supported garment Types',
      fields: [
        {
          label: 'Denim',
          name: 'supported.denim',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Knits',
          name: 'supported.knits',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Sweaters',
          name: 'supported.sweaters',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Wovens',
          name: 'supported.wovens',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Detail other supported garment types',
          name: 'supported.otherSupportedGarmentTypes',
          required: true,
          type: 'text',
        },
      ],
    },
    {
      title: 'Employee Details',
      fields: [
        {
          label: 'Number of Employees',
          name: 'numberOfEmployees',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Sewing Operators',
          name: 'numberOfSewingOperators',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Sewing Production Lines',
          name: 'numberOfSewingProductionLines',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Knitters',
          name: 'numberOfKnitters',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Pattern Makers',
          name: 'numberOfPatternMakers',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Sample Makers',
          name: 'numberOfSampleMakers',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Designers',
          name: 'numberOfDesigners',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Number of Graphic Designers',
          name: 'numberOfGraphicDesigners',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
      ],
    },
    {
      title: 'Product Types You can create',
      fields: [
        {
          label: 'Woven Tops',
          name: 'wovenTops',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Woven Bottoms',
          name: 'wovenBottoms',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Jeans',
          name: 'jeans',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Outerwear/ Jackets',
          name: 'outerwearJackets',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Knits',
          name: 'knits',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Sweaters',
          name: 'sweaters',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Tailored/ Suits',
          name: 'tailoredSuits',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Swim',
          name: 'swim',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Dresses',
          name: 'dresses',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Jumpsuits',
          name: 'jumpsuits',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Shoes',
          name: 'shoes',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Costumes',
          name: 'costumes',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Other (non apparel, jewelry, handbags)',
          name: 'other',
          required: true,
          type: 'yes_no',
        },
      ],
    },
    {
      title: 'Sub-contracting',
      fields: [
        {
          label: 'Do you subcontract any work?',
          name: 'subcontract',
          required: true,
          type: 'yes_no',
        },
      ],
    },
    {
      title: 'Absolute Program minimums',
      fields: [
        {
          label: 'Per style',
          name: 'perStyle',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Per color',
          name: 'perColor',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Per SKU (size)',
          name: 'perSku',
          required: true,
          type: 'text',
          inputType: 'number',
          specialValidation: Joi.number().integer().min(0),
        },
      ],
    },
    {
      title: 'Production Lead Time',
      fields: [
        {
          label: 'Average Lead Time (Weeks)',
          name: 'averageLeadTime',
          required: true,
          type: 'text',
          inputType: 'number',
          suffix: 'Weeks',
          specialValidation: Joi.number().integer().min(0),
        },
        {
          label: 'Reorder Lead Time (Weeks)',
          name: 'reorderLeadTime',
          required: true,
          type: 'text',
          inputType: 'number',
          suffix: 'Weeks',
          specialValidation: Joi.number().integer().min(0),
        },
      ],
    },
    {
      title: 'List of Low Production Months',
      fields: [
        {
          label: 'List of Low Production Months',
          name: 'lowProductionMonths',
          required: true,
          type: 'text',
        },
      ],
    },
    {
      title: 'List of Peak Production Months',
      fields: [
        {
          label: 'List of Peak Production Months',
          name: 'peakProductionMonths',
          required: true,
          type: 'text',
        },
      ],
    },
    {
      title: 'Additional comments',
      fields: [
        {
          label: 'Additional comments',
          name: 'additionalComments',
          type: 'text',
          multiline: 5,
        },
      ],
    },
  ],
};
